import React, { useEffect, useState } from 'react';
import { getData } from '../../../../utils/api';
import './index.css';
import newlogo from "../../../../static/img/newlogo.png";
export const ZxyzListNewBox = () => {
  const [list, setList] = useState({});

  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    const res = await getData('/api/user/zhengshu', 'post');
    if (res?.data?.code == 1) {
      setList(res.data.data[0] || {});
    }
  };

  const closeReport = (id) => {
    if (window.closeReport) {
      window.closeReport(id);
    }
  };
	const now = new Date();
	now.setMonth(now.getMonth() + 1);
	
	// 格式化为 YYYY-MM-DD
	const year = now.getFullYear();
	const month = String(now.getMonth() + 1).padStart(2, '0');
	const day = String(now.getDate()).padStart(2, '0');
	const futureDate = `${year}-${month}-${day}`;
	
  return (
    <div className="chsi-wide-layout">
      {/* 顶部主导航栏 */}
      <header className="chsi-wide-header">
        <div className="chsi-wide-container header-flex">
          {/* Logo 区域 */}
          <div className="chsi-wide-logo">
            <img src={newlogo} />
          </div>

          {/* 顶部主菜单 */}
          <nav className="chsi-wide-nav">
            <a href="/my.chsi/index">首页</a>
            <a href="/my.chsi/index">高等教育信息</a>
            <a href="/my.chsi/index" className="active">
              在线验证报告
              <span className="active-triangle-down"></span>
            </a>
            <a href="/my.chsi/index">学历学位认证与成绩验证</a>
            <a href="/my.chsi/index">出国（境）报告发送</a>
            <a href="/my.chsi/index">调查/投票</a>
            <a href="/my.chsi/index">职业测评</a>
            <a href="/my.chsi/index">就业</a>
          </nav>

          {/* 用户中心图标 */}
          <div className="chsi-wide-user">
            <div className="avatar-circle">
              <svg viewBox="0 0 1024 1024" width="18" height="18" fill="#ffffff">
                <path d="M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384z m0 64c-176 0-512 88-512 256v64h1024v-64c0-168-336-256-512-256z"/>
              </svg>
            </div>
            <span className="caret-down">▼</span>
          </div>
        </div>
      </header>

      {/* 第二排二级导航 */}
      <div className="chsi-wide-subnav">
        <div className="chsi-wide-container subnav-flex">
          <a href="#/sub-index">首页</a>
          <a href="#/sub-xj" className="active">高等学籍</a>
          <a href="#/sub-xl">高等学历</a>
          <a href="#/sub-xw">学位</a>
          <a href="#/sub-apply">协助申请</a>
        </div>
      </div>

      {/* 主卡片内容区 */}
      <main className="chsi-wide-main">
        <div className="chsi-wide-card">
          {/* 专业信息绿底标签 */}
          <div className="badge-tag">
            {list.xueli_level && list.school_name
              ? `${list.xueli_level}-${list.school_name}`
              : '本科-天津城建大学-计算机科学与技术'}
          </div>

          {/* 标题 */}
          <div className="section-title">
            <span className="check-badge">✓</span>
            <span>已申请的报告</span>
          </div>

          {/* 数据表格 */}
          <table className="chsi-wide-table">
            <thead>
              <tr>
                <th style={{ width: '22%', textAlign: 'left', paddingLeft: '28px' }}>在线验证码</th>
                <th style={{ width: '15%', textAlign: 'center' }}>语种</th>
                <th style={{ width: '20%', textAlign: 'center' }}>有效期</th>
                <th style={{ width: '15%', textAlign: 'center' }}>状态</th>
                <th style={{ width: '28%', textAlign: 'left', paddingLeft: '45px' }}>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: 'left', paddingLeft: '28px' }}>
                  <a className="table-link font-code" href={'/XlReport?id=' + (list.online_code || '')} target="_blank" rel="noreferrer">
                    {list.online_code || '869574756353'}
                  </a>
                </td>
                <td style={{ textAlign: 'center' }}>中文</td>
                <td style={{ textAlign: 'center' }}>{futureDate}</td>
                <td style={{ textAlign: 'center' }}>有效</td>
                <td style={{ textAlign: 'left', paddingLeft: '45px' }}>
                  <div className="table-actions">
                    <a className="table-link" href={'/XlReport?id=' + (list.online_code || '')} target="_blank" rel="noreferrer">
                      查看
                    </a>
                    <a className="table-link" href="https://my.chsi.com.cn/archive/bab/xj/prolong.action?bgid=dsr4f5mq5ysfn54o" target="_blank" rel="noreferrer">
                      延长验证有效期
                    </a>
                    <a className="table-link" href="javascript:void(0)" onClick={() => closeReport('dsr4f5mq5ysfn54o')}>
                      关闭
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>

      {/* 页脚 */}
      <footer className="chsi-wide-footer">
        <div className="footer-row">
          <a href="https://www.chsi.com.cn/" target="_blank" rel="noreferrer">学信网</a>
          <span className="divider">|</span>
          <a href="https://my.chsi.com.cn/archive/help/index.action" target="_blank" rel="noreferrer">帮助中心</a>
          <span className="divider">|</span>
          <span>Copyright © 2003-2026 学信网 All Rights Reserved</span>
        </div>
        <div className="footer-row" style={{ marginTop: '10px' }}>
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noreferrer">京ICP备19004913号-1</a>
          <span className="police-link">
            <img src="https://t3.chei.com.cn/chsi/images/jgwab.svg" alt="police" />
            <a href="https://www.beian.gov.cn/" target="_blank" rel="noreferrer">京公网安备11010202009747号</a>
          </span>
        </div>
      </footer>
    </div>
  );
};
export default ZxyzListNewBox;
